import { useState } from 'react'
import { useUsersAPI } from 'src/API/central.usersAPI'
import { MultiselectStandard } from 'src/components/standard.multiselect'
import { TablePlater } from 'src/components/standard.table'
import { TypographyLead, TypographySmall, TypographyStandardP1, TypographyStandardTitleH2 } from 'src/components/typography'
import { getRandomHexColor, getRelativeTime, stringToColor } from 'src/lib/utils'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'src/shadcn/ui/accordion'
import { Pagination, PaginationKeys } from 'src/types/pagination'
import { ProjectComponent } from './component.projectCard'
import { useProjectsAPI } from 'src/API/central.projectsAPI'
import { useOrganizationsAPI } from 'src/API/central.organizationAPI'
import { SelectStandard } from 'src/components/standard.select'
// import { ImportExcelModal } from './component.importExcelModal'






export function ProjectsPage() {
    const { listOrganizations } = useOrganizationsAPI()

    const {
        listProjects
    } = useProjectsAPI()
    const organizations = listOrganizations()

    const [filters, setFilters] = useState<{
        organizationId?: string[],
        projectStatus?: 'completed' | 'inProgress' | 'onHold'|'dropped' | 'all'
        sortBy?: 'latestEditedFirst' | 'largeUncompletedFirst'
    }>({
        organizationId: organizations.map(organization => organization.accountId),
        projectStatus: 'all',
        sortBy: 'latestEditedFirst'
    })
    const projects = listProjects({
        filters: {
            projectStatus: filters.projectStatus === 'all' ? undefined : filters.projectStatus,
            organizationIds: filters.organizationId
        },
        sortBy: filters.sortBy
    });






    return (
        <div className=' grow  flex flex-col overflow-auto'>

            <TablePlater className=' flex flex-col gap-2'>
                {/* Buttons section */}
                <div className=' flex justify-start w-full gap-4 max-w-[300px]'>
                    <MultiselectStandard
                        title='Organization'
                        name='organization'
                        onValueChange={(e) => {
                            setFilters({
                                ...filters,
                                organizationId: e.target.value
                            })
                        }}
                        options={[
                            ...organizations.map(organization => ({
                                label: organization.accountName,
                                value: organization.accountId
                            }))
                        ]}
                        placeholder=''
                        value={filters.organizationId}
                    />
                    <SelectStandard
                        title='Status'
                        name='status'
                        onChange={(e) => {
                            setFilters({
                                ...filters,
                                projectStatus: e.target.value as 'completed' | 'inProgress'
                            })
                        }}
                        options={[
                            {
                                label: 'All',
                                value: 'all',
                            },
                            {
                                value: 'inProgress',
                                label: 'In Progress'
                            },
                            {
                                value: 'completed',
                                label: 'Completed'
                            },
                            {
                                value: 'onHold',
                                label: 'on hold'
                            },
                            {
                                value: 'dropped',
                                label: 'dropped'
                            },
                        ]}
                        value={filters.projectStatus}
                    />
                    <SelectStandard
                        title='Sort By'
                        name='status'
                        onChange={(e) => {
                            setFilters({
                                ...filters,
                                sortBy: e.target.value as any
                            })
                        }}
                        options={[

                            {
                                value: 'latestEditedFirst',
                                label: 'Latest edited first'
                            },
                            {
                                value: 'largeUncompletedFirst',
                                label: 'Uncompleted first'
                            }
                        ]}
                        value={filters.sortBy}
                    />
                </div>
                {
                    projects.map(project => {
                        return (
                            (
                                <Accordion key={project.id} type="single" collapsible className="w-full relative ">
                                    <AccordionItem value={'item-1'} >
                                        <AccordionTrigger  >
                                            <div className="grid grid-cols-1 w-full md:grid-cols-5 gap-2 gap-y-4 ">
                                                {/* project status */}
                                                <div className={` 
                                                    w-28 h-6 text-white absolute right-0 top-0 
                                                    flex items-center justify-center text-xs
                                                    rounded-tr-lg rounded-bl-md
                                                    ${project.projectStatus === 'completed' ?
                                                        'bg-green-600' :
                                                        project.projectStatus === 'inProgress' ?
                                                            'bg-yellow-600' :
                                                            project.projectStatus === 'onHold' ?
                                                                'bg-gray-600' :
                                                                'bg-gray-800'}
                                                    `}>{project.projectStatus}</div>
                                                <div className="w-full flex items-center gap-2 md:col-span-3">
                                                    <div
                                                        style={{
                                                            background: stringToColor(project.name),
                                                        }}
                                                        className="avatar min-h-12 min-w-12 max-h-12 max-w-12 flex items-center justify-center border rounded-full text-white"
                                                    >
                                                        N
                                                    </div>
                                                    <div className="flex flex-col text-start justify-center">
                                                        <TypographyLead>{project.name}</TypographyLead>
                                                        <TypographyStandardP1>{getRelativeTime(project.lastUpdateTime)}</TypographyStandardP1>
                                                    </div>
                                                </div>
                                                <div className="flex col-span-1 md:col-span-2">
                                                    <div className="flex flex-col w-full place-items-end">
                                                        <div className='h-3'></div>
                                                        <div className="flex items-center gap-2">
                                                            <TypographyStandardTitleH2>Contributors:</TypographyStandardTitleH2>
                                                            <TypographyStandardP1>{project.users.length}</TypographyStandardP1>
                                                        </div>
                                                        <div className="w-full mt-2">
                                                            <div className="flex justify-between text-xs text-gray-600">
                                                                <TypographyStandardP1>Progress</TypographyStandardP1>
                                                                <TypographyStandardP1>
                                                                    {project.completedWorkItem}/{project.totalWorkItem}
                                                                </TypographyStandardP1>
                                                            </div>
                                                            <div className="w-full h-2 bg-gray-300 rounded">
                                                                <div
                                                                    className="h-2 rounded"
                                                                    style={{
                                                                        width: `${(project.completedWorkItem / project.totalWorkItem) * 100}%`,
                                                                        backgroundColor:
                                                                            project.completedWorkItem === project.totalWorkItem
                                                                                ? 'green'
                                                                                : (project.completedWorkItem / project.totalWorkItem) >= 0.75
                                                                                    ? 'lightgreen'
                                                                                    : (project.completedWorkItem / project.totalWorkItem) >= 0.5
                                                                                        ? 'orange'
                                                                                        : 'red',
                                                                    }}
                                                                ></div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </AccordionTrigger>
                                        <AccordionContent>
                                            <div className=' flex flex-col gap-1'>
                                                {project.users.map(
                                                    project => {
                                                        return (
                                                            <ProjectComponent
                                                                TotalWorkItem={project.totalWorkItem}
                                                                completedWorkItem={project.completedWorkItem}
                                                                key={project.user.originId}
                                                                projectName={project.user.displayName}
                                                            />
                                                        )
                                                    }
                                                )}
                                            </div>
                                        </AccordionContent>
                                    </AccordionItem>
                                </Accordion>
                            )
                        )
                    })
                }


            </TablePlater>
        </div>
    )

}



